module.exports = __webpack_public_path__ + "img/dpmptsp-lumajang.d5b431c6.png";